module.exports = __webpack_public_path__ + "media/images/next-transparent-be79b86f5aaa2d338a9a486dfd0e1c04.svg";